<template>
  <div class="page-content -column -column-two">
    <h3 class="section-title -mb">Webhooks</h3>

    <label>Webhook Pending Period <small>(default: 5)</small></label>
    <p class="hint">
      The amount of time (in minutes) a webhook will wait before being automatically approved and sent.
    </p>
    <input v-model="resource.webhooks_pending_period" type="number" />
    <span v-if="errors.webhooks_pending_period" class="alert -inline -danger">
      {{ [...errors.webhooks_pending_period].join(', ') }}
    </span>

    <label>Webhook URL</label>
    <p class="hint">
      When a conversation is marked as closed, a webhook will be posted to this URL containing the conversation
      transscript along with any data collected.
    </p>
    <input v-model="resource.webhook_url" type="text" />
    <span v-if="errors.webhook_url" class="alert -inline -danger">
      {{ [...errors.webhook_url].join(', ') }}
    </span>

    <label>Webhook Signature Key</label>
    <p class="hint">Webhooks will be signed with this key for added security to ensure they are legitimate.</p>
    <input v-model="resource.webhook_signature_key" type="text" />
    <span v-if="errors.webhook_signature_key" class="alert -inline -danger">
      {{ [...errors.webhook_signature_key].join(', ') }}
    </span>

    <action-button class="-mt" :text="'Update Settings'" :state="state" @pressed="submit"></action-button>
  </div>
</template>

<script>
import actionButton from "@/components/actionButton";
import settingsBase from "@/components/settings/base.vue";

export default {
  components: { actionButton },
  extends: settingsBase,

  data() {
    return {
      fields: ["webhooks_pending_period", "webhook_url", "webhook_signature_key"]
    };
  }
};
</script>
